/**
 * @name results.controller:advancedSearch
 * @description
 * Controller for advancedSearch directive. On click open compile
 * initial view of advanced search. Keep inside couple of
 * methods for 'reset', 'select', 'back' and 'done' buttons
 */
export default function ($scope, $element, $compile, CommonFunctions, $http, config) {
    'ngInject';

    /**
     * Initial state of variables for advancedSearch directive
     */
    const mainTemplateUrl =
            `${config.get('assetsURL')}views/advancedSearch.html`;
    const listTemplateUrl =
            `${config.get('assetsURL')}views/advancedSearchList.html`;
    const errorMessageTemplateUrl =
            `${config.get('assetsURL')}views/advancedSearchErrorMessage.html`;
    const resultsTemplateUrl =
            `${config.get('assetsURL')}views/advancedSearchResults.html`;
    const titles = [];
    const initialTitle = 'Advanced Results Search';
    /* eslint-disable */
    const noMatchesMessage = 'No results found to match your search. \n Please try a different search';
    const limitedMatchesMessage = 'Your search is too broad. Please narrow your criteria and try again.';
    /* eslint-enable */
    let initialScroll = null;
    let errorMessage = '';
    let renderedViews = [];
    let initialView = null;
    let searchBody = null;
    let countryList = [];
    let itemsList = null;
    let restrictionMessage = '';
    let searchResults = [];
    let showErrorMessageTitle = true;
    let dateToLabel = '';
    let dateFromLabel = '';
    let showResults = false;

    /**
     * Container for html element
     */
    $scope.$html = angular.element('html');

    /**
     * Container for body element
     */
    $scope.$body = angular.element('body');

    /**
     * Selector for search body element
     */
    $scope.searchBodySelector = '#searchBody';

    /**
     * Constant for days in a year
     * @type {number}
     */
    $scope.EXCEEDING_DATE_YEAR = 365;

    /**
     * Constant for days in a week
     * @type {number}
     */
    $scope.EXCEEDING_DATE_WEEK = 7;

    /**
     * Constant for milliseconds in a day
     * @type {number}
     */
    $scope.MS_IN_DAY = 1000 * 60 * 60 * 24;

    /**
     * Model for search form
     * @type {object}
     */
    $scope.inputs = {
        raceTitle: '',
        countryCode: '',
        courseId: ''
    };

    /**
     * Get url for main template
     * @returns {string}
     */
    $scope.getMainTemplateUrl = () => mainTemplateUrl;

    /**
     * Get url for list template
     * @returns {string}
     */
    $scope.getListTemplateUrl = () => listTemplateUrl;

    /**
     * Get url for error message template
     * @returns {string}
     */
    $scope.getErrorMessageTemplateUrl = () => errorMessageTemplateUrl;

    /**
     * Get url for error message template
     * @returns {string}
     */
    $scope.getResultsTemplateUrl = () => resultsTemplateUrl;

    /**
     * Getter for initial title
     * @returns {string}
     */
    $scope.getInitialTitle = () => initialTitle;

    /**
     * Getter for initial scroll state
     * @returns {null|string}
     */
    $scope.getInitialScroll = () => initialScroll;

    $scope.setErrorMessage = (message) => {
        errorMessage = message;
    };

    $scope.getErrorMessage = () => errorMessage;

    /**
     * Getter for appropriate date restriction
     * @returns {string}
     */
    $scope.getRestrictionMessage = () => restrictionMessage;

    $scope.getLimitedMatchesMessage = () => limitedMatchesMessage;

    $scope.getNoMatchesMessage = () => noMatchesMessage;

    $scope.setShowResults = (boolean) => {
        showResults = boolean;
    };

    $scope.getShowResults = () => showResults;

    /**
     * Setter for appropriate date restriction
     * @param {number} date
     */
    $scope.setRestrictionMessage = (date) => {
        /* eslint-disable */
        restrictionMessage = `Please enter at least 3 characters for the title or restrict your date range to ${date} days`;
        /* eslint-enable */
    };

    $scope.setShowErrorMessageTitle = (boolean) => {
        showErrorMessageTitle = boolean;
    };

    $scope.getShowErrorMessageTitle = () => showErrorMessageTitle;

    /**
     * Setter for initial scroll state
     * @param {string} param
     */
    $scope.setInitialScroll = (param) => {
        initialScroll = param;
    };

    /**
     * Getter for initial view
     * @returns {boolean}
     */
    $scope.getInitialView = () => initialView;

    /**
     * Setter for initial view
     * @param {object} param
     */
    $scope.setInitialView = (param) => {
        initialView = param;
    };

    /**
     * Getter for list of rendered views
     * @returns {Array}
     */
    $scope.getRenderedViews = () => renderedViews;

    /**
     * Set list of rendered views to empty array
     */
    $scope.resetRenderedViews = () => {
        renderedViews = [];
    };

    /**
     * Getter for number of rendered views
     * @returns {number}
     */
    $scope.getNumberOfViews = () => renderedViews.length;

    /**
     * Getter for titles list
     * @returns {Array}
     */
    $scope.getTitles = () => titles;

    /**
     * Getter for last title in a array
     * @returns {number}
     */
    $scope.getLastTitle = () => titles[titles.length - 1];

    /**
     * Getter for body of advanced search
     * @returns {object}
     */
    $scope.getSearchBody = () => searchBody;

    /**
     * Setter for body of advanced search
     * @param {object} param
     */
    $scope.setSearchBody = (param) => {
        searchBody = param;
    };

    /**
     * Setter for country's list
     * @param {Array} data List of countries
     */
    $scope.setCountryList = (data) => {
        countryList = data;
    };

    /**
     * Getter for country's list
     */
    $scope.getCountryList = () => countryList;

    /**
     * Get list of courses from selected country
     */
    $scope.getCourseList = () => $scope.getCountryList()
        .filter($scope.helperIsSelected)[0].courses;

    /**
     * Getter for itemsList
     * @returns {Array}
     */
    $scope.getItemsList = () => itemsList;

    /**
     * Setter for itemsList
     * @param {Array} list List of items to be rendered in Advanced search list view
     */
    $scope.setItemsList = (list) => {
        itemsList = list;
    };

    /**
     * Getter for searchResults
     * @returns {Array}
     */
    $scope.getSearchResults = () => searchResults;

    /**
     * Getter for searchResults
     * @returns {Array}
     */
    $scope.isSearchResultsEmpty = () => !$scope.getSearchResults().length;

    /**
     * Setter for searchResults
     * @param {Array} data Results search response
     */
    $scope.setSearchResults = (data) => {
        searchResults = data;
    };

    $scope.setDateToLabel = (string) => {
        dateToLabel = string;
    };

    $scope.getDateToLabel = () => dateToLabel;

    $scope.setDateFromLabel = (string) => {
        dateFromLabel = string;
    };

    $scope.getDateFromLabel = () => dateFromLabel;

    const stopHandler = (e) => {
        e.stopPropagation();
    };

    $scope.setDefaultDateLabels = () => {
        $scope.setDateToLabel(moment().format('DD MMM YYYY'));
        $scope.setDateFromLabel(moment().subtract(7, 'days').format('DD MMM YYYY'));
    };
    /**
     * Get property name from selected item. Depends on type of select
     * @param {string} type Type of select ('Country' or 'Course')
     * @returns {string} Value of selected item property name
     */
    $scope.getSelectedItemName = (type) => {
        const list = $scope.getCountryList();
        const result = list.filter($scope.helperIsSelected)[0];
        return type === 'Country' ?
            result.name : result.courses.filter($scope.helperIsSelected)[0].name;
    };

    /**
     * Get selected element. Used in Array.filter() method
     * @param {object} element Element of array
     * @returns {object} Array with one element, which property 'isSelected' is true
     */
    $scope.helperIsSelected = (element) => element.isSelected;

    /**
     * Unset property 'isSelected', and if was used for country
     * select reset courses. Used in Array.some() method
     * @param {object} element Element of an array
     * @param {number} index Index of current element in array
     * @param {Array} array Array on which was called some()
     */
    $scope.helperUnsetSelected = (element, index, array) => {
        if (element.isSelected) {
            if (element.hasOwnProperty('courses')) {
                $scope.resetSelection(array[index].courses);
            }

            array[index].isSelected = false;
        }
    };

    /**
     * Select item from the list and return user to previous view
     * @param {object} event Event object
     * @param {Array} list List of items
     * @param {number} index Index of item, which should be selected
     */
    $scope.chooseItem = (event, list, index) => {
        event.stopPropagation();
        $scope.setSelectedItem(list, index);
        $scope.back();
    };

    /**
     * Set property 'isSelected' to 'true'
     * @param {Array} list List of items
     * @param {number} index Index of item, which should be selected
     */
    $scope.setSelectedItem = (list, index) => {
        list.some($scope.helperUnsetSelected);
        list[index].isSelected = true;
        $scope.getSelectedItemParam(list[index]);
    };

    /**
     * Get property name from selected item. Depends on type of select
     * @returns {string} Value of selected item property name
     */
    $scope.getSelectedItemParam = (selectedItem) => {
        if (selectedItem.hasOwnProperty('countryCode')) {
            $scope.inputs.countryCode = selectedItem.countryCode;
        } else {
            $scope.inputs.courseId = selectedItem.courseId;
        }
    };

    /**
     * Reset to default state current list
     * @param {Array} list List of items
     */
    $scope.resetSelection = (list) => {
        $scope.setSelectedItem(list, 0);
    };

    /**
     * Remove last title from array and last rendered view from the page
     */
    $scope.back = () => {
        $scope.getInitialView().on('click', stopHandler);
        $scope.getTitles().pop();
        $scope.getRenderedViews().pop().remove();
        $scope.$broadcast('datePickerHide');
    };

    /**
     * Reset search items to default state
     */
    $scope.reset = (manual) => {
        $scope.inputs.raceTitle = '';
        $scope.initDate();
        if (manual) {
            $scope.$broadcast('datePickerReset', {
                to: $scope.inputs.dateTo,
                from: $scope.inputs.dateFrom
            });
        } else {
            $scope.$broadcast('datePickerDestroy');
        }
        $scope.setDefaultDateLabels();
        $scope.resetSelection($scope.getCountryList());
    };

    /**
     * Render view on the page
     * @param {string} templateUrl Link for appropriate template
     * @param {object} parent Object where should be rendered new view
     * @param {boolean} initial Flag for initial render
     */
    $scope.renderView = (templateUrl, parent, initial) => {
        let view = null;

        $http.get(templateUrl).success((data) => {
            view = $compile(data)($scope);
            parent.append(view);

            if (initial) {
                $scope.setInitialView(view);
                $scope.setSearchBody($scope.getInitialView().find($scope.searchBodySelector));
                $scope.setPosition();
                $scope.$broadcast('datePickerInit', {
                    to: $scope.inputs.dateTo,
                    from: $scope.inputs.dateFrom,
                    container: $scope.getSearchBody()
                });
                $scope.getInitialView().on('click', stopHandler);
            } else {
                $scope.getRenderedViews().push(view);
            }
        }).finally(() => {
            $scope.rendering = false;
        });
    };

    /**
     * Init default states for dateRange inputs
     */
    $scope.initDate = () => {
        $scope.inputs.dateFrom = moment().subtract(7, 'days').format('YYYY-MM-DD');
        $scope.inputs.dateTo = moment().format('YYYY-MM-DD');
    };

    $scope.$on('datePickerShow', (event, data) => {
        const title = `Choose Date (${data})`;
        const view = angular.element();

        $scope.getRenderedViews().push(view);
        $scope.getTitles().push(title);
        $scope.$apply();
    });

    $scope.$on('datePickerHidden', () => {
        if ($scope.getNumberOfViews()) {
            $scope.back();
            $scope.$apply();
        }
    });

    $scope.$on('datePickerChange', (event, data) => {
        const date = data.date.format('YYYY-MM-DD');
        const label = data.date.format('DD MMM YYYY');
        if (data.type === 'from') {
            $scope.inputs.dateFrom = date;
            $scope.setDateFromLabel(label);
        } else {
            $scope.inputs.dateTo = date;
            $scope.setDateToLabel(label);
        }

        $scope.$broadcast('datePickerChanged', data);
    });

    /**
     * Render view for select button, form and save its title in a list of titles
     * @param {string} type
     */
    $scope.openSelect = (type) => {
        if ($scope.rendering) return;
        $scope.rendering = true;
        const title = `Choose ${type}`;
        const list = (type === 'Country') ? $scope.getCountryList() : $scope.getCourseList();
        $scope.getTitles().push(title);
        $scope.setItemsList(list);
        $scope.renderView($scope.getListTemplateUrl(), $scope.getSearchBody(), false);
    };

    /**
     * Prevent page scrolling
     */
    $scope.preventScroll = () => {
        $scope.$html.css({ overflowY: 'hidden' });
        $scope.$body.css({ position: 'fixed', width: '100%' });
    };

    /**
     * Activate page scrolling
     */
    $scope.activateScroll = () => {
        $scope.$html.css({ overflowY: $scope.getInitialScroll() });
        $scope.$body.css({ position: '', width: '' });
    };

    /**
     * Save initial state of page scroll, remove scrolling from page,
     * push initial title to the list,
     * render initial view append the body of a page
     */
    $scope.openSearch = (event) => {
        event.preventDefault();
        if ($scope.rendering || $scope.getInitialView()) return;
        $scope.rendering = true;
        $scope.initDate();
        $scope.setDefaultDateLabels();
        $scope.setInitialScroll($scope.$html.css('overflow-y'));
        $scope.getTitles().push($scope.getInitialTitle());
        $scope.renderView($scope.getMainTemplateUrl(), $scope.$body, true);
        $scope.$body.on('click', $scope.closeSearch);
    };

    /**
     * Set initial scroll for the page, remove all rendered views from the page
     */
    $scope.closeSearch = (event, force) => {
        if ($scope.getInitialView() &&
            !$scope.getInitialView()[0].contains(event.target) || force) {
            $scope.reset();
            $scope.resetRenderedViews();
            $scope.getInitialView().off('click', stopHandler);
            $scope.getInitialView().remove();
            $scope.setInitialView(null);
            $scope.activateScroll();
            $scope.$body.off('click', $scope.closeSearch);
        }
    };

    /**
     * Check breakpoint and change a position of advanced search
     */
    $scope.setPosition = () => {
        if ($scope.getInitialView()) {
            const currentSize = CommonFunctions.getScreenSize();
            if (currentSize === 'extraNarrow' ||
                currentSize === 'narrow') {
                $scope.getInitialView().css({ top: 0, left: 'auto' });
                $scope.preventScroll();
            } else {
                const view = $scope.getInitialView();
                const searchBox = view[0].getBoundingClientRect();
                const position = CommonFunctions.getOffsetRect($element[0], searchBox, currentSize);
                $scope.activateScroll();
                if (position.left > (searchBox.width / 2)) {
                    view.removeClass('align_left');
                } else {
                    view.addClass('align_left');
                }

                view.css({
                    top: position.top,
                    left: position.left
                });
            }
        }
    };

    /**
     * Perform AJAX request and set data into variable
     */
    $scope.getApiData = () => {
        const url = `${config.get('resultsPath')}/data/courses.json`;

        $http.get(url).success((data) => {
            $scope.setCountryList(data);
        });
    };

    /**
     * Perform AJAX request and set data into variable
     */
    $scope.requestSearchResults = () => {
        /* eslint-disable */
        const optionalParams = window.btoa(
            encodeURI(`${$scope.inputs.raceTitle}/${$scope.inputs.countryCode}/${$scope.inputs.courseId}`));
        const url = `${config.get('resultsPath')}/data/search/${optionalParams}/${$scope.inputs.dateFrom}/${$scope.inputs.dateTo}.json`;
        /* eslint-enable */
        $http.get(url).success((data) => {
            $scope.showSearchResults(data);
        }).error(() => {
            $scope.showPostRequestMessage($scope.getNoMatchesMessage());
        });
    };

    $scope.showSearchResults = (data) => {
        if (!data.results.length) {
            $scope.showPostRequestMessage($scope.getNoMatchesMessage());
        } else if (data.overLimit) {
            $scope.showPostRequestMessage($scope.getLimitedMatchesMessage());
        } else {
            $scope.getTitles().push($scope.createResultTitle(data.results.length));
            $scope.setSearchResults(data.results);
            $scope.getInitialView().off('click', stopHandler);
        }
    };

    $scope.showPostRequestMessage = (message) => {
        $scope.setErrorMessage(message);
        $scope.setShowErrorMessageTitle(false);
        $scope.setShowResults(true);
    };

    $scope.createResultTitle = (matches) =>
        matches + (matches === 1 ? ' Match' : ' Matches');

    /**
     * Calculate range of selected dates
     * @returns {number}
     */
    $scope.calculateDateRange = () =>
    (new Date($scope.inputs.dateTo) - new Date($scope.inputs.dateFrom)) / $scope.MS_IN_DAY;
    /**
     * Start search, check for restriction and render appropriate view
     */
    $scope.triggerSearch = () => {
        let viewUrl;
        $scope.rendering = true;
        $scope.getTitles().push($scope.getInitialTitle());
        $scope.setShowResults(false);

        if ($scope.checkForRestrictions()) {
            viewUrl = $scope.getResultsTemplateUrl();
            $scope.setSearchResults([]);
            $scope.requestSearchResults();
        } else {
            viewUrl = $scope.getErrorMessageTemplateUrl();
            $scope.setErrorMessage($scope.getRestrictionMessage());
            $scope.setShowErrorMessageTitle(true);
        }

        $scope.renderView(viewUrl, $scope.getSearchBody(), false);
    };

    /**
     * Render error message in case selected parameters for search isn't pass restrictions
     * @returns {boolean}
     */
    $scope.checkForRestrictions = () => {
        if ($scope.calculateDateRange() > $scope.EXCEEDING_DATE_WEEK &&
            (!$scope.inputs.raceTitle || $scope.inputs.raceTitle.length < 3)) {
            // TODO: Change to appropriate value, when Tesla provide an example of required params
            if ($scope.getSelectedItemName('Course') !== 'Course (any)') {
                if ($scope.calculateDateRange() > $scope.EXCEEDING_DATE_YEAR) {
                    $scope.setRestrictionMessage($scope.EXCEEDING_DATE_YEAR);
                } else {
                    return true;
                }
            } else {
                $scope.setRestrictionMessage($scope.EXCEEDING_DATE_WEEK);
            }
        } else {
            return true;
        }

        return false;
    };

    /**
     * Add click handler for element.
     */
    $scope.init = () => {
        $scope.getApiData();
        $element.on('click', $scope.openSearch);
        $(window).on('resize', $scope.setPosition);
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveAdvancedSearch.js